import { useEffect } from 'react';

const loaded = new Set();

// Loads Google Fonts families (css2 query strings, e.g. "Bitter:ital,wght@0,400;0,700") once per page, so the font
// pickers and previews show each face as it prints. The PDFs embed their own copies.
export default function useGoogleFonts(queries) {
  const key = (queries || []).filter(Boolean).join('|');
  useEffect(() => {
    key.split('|').filter(Boolean).forEach((q) => {
      if (loaded.has(q)) return;
      loaded.add(q);
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = `https://fonts.googleapis.com/css2?family=${q}&display=swap`;
      document.head.appendChild(link);
    });
  }, [key]);
}
